import { createSlice } from "@reduxjs/toolkit";
import { IClone } from "src/@types/clones";
import { CURRENT_CLONE_SLICE_NAME } from "./actions";
import { getCurrentCloneReducer } from "./reducers";

export interface CurrentCloneState {
  isLoading: boolean;
  item: IClone;
}

const initialState: CurrentCloneState = {
  isLoading: false,
  item: null,
};

export const { reducer: currentClone } = createSlice({
  name: CURRENT_CLONE_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getCurrentCloneReducer(builder);
  },
});
